import { render, staticRenderFns } from "./TableRiskFactor.vue?vue&type=template&id=338a1422&scoped=true"
import script from "./TableRiskFactor.vue?vue&type=script&lang=js"
export * from "./TableRiskFactor.vue?vue&type=script&lang=js"
import style0 from "./TableRiskFactor.vue?vue&type=style&index=0&id=338a1422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a1422",
  null
  
)

export default component.exports